import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Generic shimmer skeleton for form-style pages, mirroring the shimmer used in
 * `app-table-reusable`. Shown while a page's GET request is in flight, so the
 * layout does not pop in empty. Defaults render a header + a two-column grid of
 * label/field placeholders; tune via inputs to match a given page's shape.
 */
@Component({
  selector: 'app-form-skeleton',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './form-skeleton.html',
  styleUrl: './form-skeleton.css',
})
export class FormSkeletonComponent {
  /** Show the heading/subheading block at the top. */
  @Input() showHeader = true;
  /** Number of summary/stat card placeholders (0 hides the row). */
  @Input() cards = 0;
  /** Number of field rows in the grid (0 hides the grid). */
  @Input() rows = 8;
  /** Columns the field grid splits into on larger screens. */
  @Input() columns: 1 | 2 | 3 = 2;

  get fieldItems(): undefined[] {
    const count = Number.isFinite(this.rows) && this.rows >= 0 ? this.rows : 8;
    return Array.from({ length: count });
  }

  get cardItems(): undefined[] {
    const count = Number.isFinite(this.cards) && this.cards > 0 ? this.cards : 0;
    return Array.from({ length: count });
  }

  get gridColumnsClass(): string {
    switch (this.columns) {
      case 1:
        return 'sm:grid-cols-1';
      case 3:
        return 'sm:grid-cols-3';
      default:
        return 'sm:grid-cols-2';
    }
  }
}
